export default __webpack_public_path__ + "static/media/golden_bee.270c7548.jpg";